import ReactComponent from '@/assets/icons/multi-line.svg?react';
import { CSSProperties } from 'react';

export interface UploadIconProps {
    color?: string;
    height?: number;
    style?: CSSProperties;
    className?: string;
    onClick?: () => void;
}

const Icon = ({
    color = '#757A7B',
    height = 20,
    style,
    className,
    onClick,
}: UploadIconProps) => {
    return (
        <ReactComponent
            height={height}
            stroke={color}
            style={{ minWidth: (height * 16) / 20, ...style }}
            className={className}
            onClick={onClick}
        />
    );
};
export default Icon;
